export default __webpack_public_path__ + "static/media/285200743_5109604749152872_8198923549661396365_n.adaa8405.jpg";